var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdonet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 56 L 91 56.5 L 88 58 L 88 56 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 56 L 122.5 58 L 121.5 56 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 56 L 133 56.5 L 130.5 57 L 130.5 56 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 58 L 114 60 L 112 59.5 L 113.5 58 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 61 Q 97.1 60.3 96 63 L 88.5 64 L 88.5 63 L 94.5 61 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 63 L 113.5 65 L 110 64.5 L 114.5 63 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105 64 L 107 64.5 L 105 65.5 L 105 64 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 64 L 152.5 64 L 154 64.5 L 152 65.5 L 154 66 Q 155 69 152 68 L 150.5 64 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 64 L 158.5 66 L 160 65.5 L 157 67.5 L 155.5 64 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 66 L 106.5 68 L 107.5 66 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 68 L 109.5 71 L 111.5 68 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 72 L 136 72.5 Q 133.3 73.6 134 77 L 132 76.5 L 134 73.5 L 133.5 72 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 74 Q 95 77.5 96.5 75 Q 98.8 74.3 98 76.5 L 96 76.5 L 95.5 78 L 93.5 74 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 76 L 157 79.5 L 155 78.5 L 156.5 76 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 77 L 93 78.5 L 91.5 79 L 90.5 77 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 77 L 129 78.5 L 127.5 79 L 126.5 77 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 77 L 137 78.5 L 135 79.5 L 136.5 77 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87 81 L 89 81.5 L 87 82.5 L 87 81 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 81 L 97.5 83 L 98.5 81 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 82 L 92 83.5 L 91.5 85 L 91 83.5 L 92.5 82 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 82 L 130.5 84 L 131.5 82 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 83 L 127 84.5 L 125 85.5 L 126.5 83 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 83 L 155 84.5 L 153 85.5 L 154.5 83 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 86 L 39.5 86 L 40 88 L 32.5 88 L 32 86 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 86 L 157.5 88 L 159 88.5 L 157.5 89 Q 154.5 87.5 157.5 86 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 87 L 80 88.5 L 79.5 90 L 78 89.5 L 77.5 91 L 77 89.5 L 80.5 87 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 88 L 49 89.5 L 47 90.5 L 48.5 88 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 88 L 63.5 90 L 62.5 88 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 88 L 68 90.5 L 66 91.5 L 67 89.5 L 66.5 88 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30 90 L 32 90.5 L 30 91.5 L 30 90 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 91 L 121 93.5 L 118.5 92 L 117.5 91 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 92 L 27 94.5 L 26 94.5 L 26.5 92 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 94 L 88 96 L 86 95.5 L 87.5 94 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106 94 L 109.5 95 L 111.5 94 L 111.5 95 L 109.5 96 L 107.5 95 L 106 95.5 L 106 94 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 95 L 130 96.5 L 130 104 L 128 103.5 L 128.5 95 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 97 L 149 98 Q 150 101 147 100 Q 148.1 97.3 145.5 98 L 145.5 97 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 99 L 93 102.5 L 93 104 L 88 104 L 88 99 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 100 Q 39.5 101.5 36.5 103 L 36.5 100 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 102 L 68.5 105 L 67.5 103 Q 69 105.5 70.5 102 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 103 L 48.5 105 L 49.5 103 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139 104 L 142.5 105 L 144 104.5 L 141.5 106 L 139 105.5 L 139 104 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 107 L 94.5 109 L 93.5 107 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 107 L 164.5 109 L 165.5 107 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 111 L 60 112 L 60 119.5 L 58.5 120 L 57 120.5 Q 59.8 118.8 58 112.5 L 57.5 111 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 111 L 64 119.5 L 63 119.5 L 63.5 111 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 111 L 168 114.5 L 165 112.5 L 165.5 111 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 112 L 32 113.5 L 31.5 115 L 31 113.5 L 32.5 112 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 114 L 25 115.5 L 26 117.5 L 24 116.5 L 25.5 114 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 117 L 28.5 119 L 27.5 117 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 117 L 161 119 L 164 119.5 L 160 120 L 160.5 117 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 121 L 134.5 123 L 133.5 121 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 121 L 152.5 123 L 153.5 121 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 123 L 50 125.5 L 48 124.5 L 48.5 123 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 124 L 124 125.5 L 122.5 126 L 120.5 124 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 126 L 42.5 128 L 41.5 126 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 126 L 93.5 128 L 94.5 126 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 127 L 133 128 L 129.5 133 L 128 132.5 L 128.5 127 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 128 L 143.5 128 L 144 130 L 136.5 130 L 136 128 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 56 L 93 56.5 L 88.5 59 L 88.5 58 L 91.5 56 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 57 L 141 57.5 L 138.5 58 L 138.5 57 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 58 L 144.5 60 L 145.5 58 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 59 L 115.5 61 L 116.5 59 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 59 L 152 59.5 Q 149.9 62.8 149.5 59 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 61 L 94 61.5 L 88.5 63 L 89.5 61 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 61 L 150 62.5 L 148.5 63 L 147.5 61 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72 64 L 80 64 L 80 66.5 L 80 68.5 L 80 72 L 72 72 L 72 64 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 65 L 83.5 67 L 84.5 65 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 74 L 159 77.5 L 158 77.5 L 158.5 74 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98 75 L 100 75.5 L 98 76.5 L 98 75 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 76 Q 132.5 77.5 129.5 79 L 129.5 76 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 78 L 97 79.5 L 95.5 80 L 94.5 78 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 79 L 135.5 81 L 134 80.5 L 136.5 79 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 80 L 43 80 L 43 88 Q 38.8 89 39.5 86 L 32.5 86 L 32.5 85 L 40 85 L 40 82 L 32.5 82 L 32 80 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72 80 L 80 80 L 80 88 L 72 88 L 72 80 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 81 L 129.5 83 L 130.5 81 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 82 L 137 82.5 L 133.5 84 L 134.5 82 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 84 L 155 86.5 L 154 86.5 L 153.5 85 L 152 85.5 L 153.5 84 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 87 L 150.5 89 L 151.5 87 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 88 L 54.5 90 L 53.5 88 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 89 L 151.5 91 L 152.5 89 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 90 L 83.5 93 L 81 92 L 81.5 90 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 92 L 113.5 94 L 112.5 92 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 94 L 84.5 96 Q 91.5 94.5 91 97.5 L 96 101 Q 97.5 105.5 93 104 L 89.5 99 L 88 99 L 88 104 L 80 104 L 80.5 95 L 82.5 96 L 84.5 94 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 95 L 117.5 96 Q 118.8 93.7 120 96.5 L 120 103.5 L 121.5 104 L 122.5 106 Q 119.4 102.4 112 104 L 112 96.5 L 113.5 96 L 114.5 95 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130 96 L 134 96 L 134 104 L 130 104 L 130 96 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 102 L 145.5 104 L 144 103.5 L 146.5 102 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 108 L 148.5 110 L 147.5 108 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 109 L 72 111.5 L 71.5 116 L 70 110.5 L 71.5 109 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 110 L 149.5 112 L 150.5 110 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 112 L 58 119.5 L 57 119.5 L 57.5 112 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 112 L 63 119.5 L 62 119.5 L 62.5 112 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 112 L 99 112 L 99 120 Q 93.8 121.8 96 114.5 Q 93.7 113.3 96.5 112 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 115 L 26.5 117 Q 23.7 117.7 25.5 115 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57 121 L 59 121.5 L 57 122.5 L 57 121 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 123 L 125 124.5 L 123.5 124 L 122.5 123 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 128 L 56 128 L 56 136 L 48 136 L 48 128 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 128 L 88 128 L 88 136 L 80 136 L 80 128 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104 128 L 120 128 L 120 136 L 104 136 L 104 128 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133 128 Q 137.3 127 136.5 130 L 144 130 L 144.5 128 L 163 128 L 163 136 L 144 136 L 144 133 L 136.5 133 L 136 131 L 134.5 131 L 131 136 Q 126.5 137.5 128 133 L 133 129.5 L 133 128 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 201 0 L 201 200 L 0 200 L 0 0 Z M 88 56 L 88 59 L 93 57 L 88 56 Z M 114 56 L 112 58 L 113 62 L 113 64 L 102 64 L 100 64 L 96 64 L 96 61 L 90 61 L 88 65 L 86 64 L 83 65 L 72 64 L 72 72 L 80 72 L 80 80 L 72 80 L 72 88 L 73 89 Q 71 87 69 91 L 70 88 L 68 89 L 66 88 L 67 91 L 65 92 L 65 91 Q 63 86 61 90 L 61 88 Q 58 87 59 90 Q 56 91 55 88 Q 51 88 50 91 L 52 91 L 54 90 L 52 93 L 49 92 L 50 88 L 48 89 L 46 88 L 46 90 L 46 91 L 43 88 L 43 80 L 32 80 L 33 82 L 40 82 L 40 85 L 33 85 L 32 88 L 30 88 L 30 90 L 29 88 L 27 92 L 25 89 L 24 89 L 26 94 L 25 96 L 27 97 L 26 97 L 24 97 L 25 101 L 25 99 L 26 99 L 25 103 L 29 104 L 30 104 L 27 102 Q 26 99 29 100 L 31 102 L 30 99 L 31 99 Q 30 101 33 100 L 35 100 Q 37 99 36 102 L 35 101 L 33 104 L 35 104 L 36 104 Q 37 106 33 105 L 32 108 L 33 111 Q 31 115 30 112 L 29 115 L 28 112 L 27 116 L 26 112 L 24 116 L 25 120 L 27 120 L 26 118 L 28 118 L 28 117 L 30 117 L 30 116 L 31 116 L 30 119 L 28 119 L 29 121 L 27 126 Q 23 125 24 128 L 26 127 L 33 128 L 35 128 L 38 128 L 36 127 Q 35 124 38 125 L 40 128 L 42 127 L 45 128 L 48 128 L 48 136 L 56 136 L 56 128 L 67 128 L 65 127 L 68 125 L 70 120 L 71 120 L 70 124 L 72 126 Q 74 125 73 128 L 78 127 L 80 129 L 80 136 L 88 136 L 88 129 L 87 128 Q 89 124 95 124 L 93 123 L 95 118 L 95 122 L 96 122 Q 95 118 99 120 L 99 112 L 96 112 L 95 108 L 96 106 Q 98 100 95 101 L 90 96 L 93 95 L 90 94 Q 88 96 87 94 L 90 93 Q 95 92 97 96 L 99 95 L 112 96 L 113 96 Q 110 97 112 104 L 113 107 L 112 114 L 113 117 L 112 119 L 113 121 L 113 123 L 112 121 L 111 121 L 109 120 L 111 124 Q 109 121 105 122 L 104 125 L 106 128 L 105 127 L 104 136 L 120 136 L 120 129 Q 122 127 119 126 L 120 124 L 121 127 L 123 126 Q 125 125 124 128 L 126 128 L 125 125 L 124 122 L 128 128 L 128 136 L 131 136 L 135 131 L 136 131 L 137 133 L 144 133 L 145 136 L 163 136 L 163 128 L 164 127 L 162 123 L 165 125 L 164 128 L 166 128 L 167 126 L 167 128 L 168 128 L 168 126 L 164 120 L 167 121 L 168 118 L 166 119 L 162 119 L 166 118 L 160 117 L 166 116 Q 167 113 165 114 L 163 115 L 164 113 L 166 113 L 165 110 Q 164 107 167 108 L 168 106 L 166 107 L 159 107 L 168 105 L 168 104 L 164 105 L 162 104 L 158 106 L 156 106 L 158 105 L 158 104 L 155 105 L 153 104 L 153 106 L 151 106 L 152 104 L 150 102 L 146 103 L 147 101 L 151 102 L 152 102 L 149 100 L 152 99 L 152 98 Q 147 99 148 97 L 149 95 L 147 96 L 146 94 L 149 93 L 149 95 L 151 96 L 150 96 L 150 97 L 155 96 L 157 96 L 159 96 L 156 93 Q 153 92 154 95 L 153 95 L 154 93 L 153 91 L 154 89 L 154 91 L 159 89 L 157 88 L 160 82 L 159 80 L 159 72 L 160 71 Q 160 66 157 64 L 155 65 Q 159 67 158 72 L 156 72 L 156 67 L 154 67 L 154 64 Q 151 65 152 62 L 146 59 Q 145 55 150 57 L 150 56 L 145 57 L 143 56 L 137 57 L 135 57 L 133 56 Q 129 55 130 58 L 124 58 L 128 57 L 128 56 Q 122 55 121 57 L 114 56 Z M 151 57 L 147 59 L 152 61 L 152 57 L 151 57 Z M 158 90 L 157 94 L 158 94 L 158 90 Z M 33 101 L 31 104 L 33 103 L 33 101 Z M 168 108 L 166 114 L 168 115 L 168 108 Z M 25 120 L 25 123 L 24 125 L 26 125 L 28 121 L 27 121 L 25 120 Z M 104 120 L 105 122 L 107 121 L 104 120 Z M 168 121 L 167 124 L 168 124 L 168 121 Z M 70 125 L 67 127 L 69 127 L 70 128 L 70 125 Z M 93 125 L 90 128 L 92 128 L 94 128 Q 96 129 95 126 L 93 125 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114 57 L 118 57.5 L 114.5 59 L 114 57 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 58 L 122 59.5 L 118.5 63 L 117 62.5 L 120.5 58 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 59 L 116 61.5 Q 116.7 64.1 114 63 Q 112.9 60.3 115.5 61 L 117.5 59 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 66 L 111 67.5 L 109.5 68 L 108.5 66 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 67 L 111.5 70 L 113.5 67 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 68 Q 154.8 67.3 154 69.5 L 154.5 71 Q 152.3 71.8 153 69.5 L 152.5 68 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 71 L 137 73.5 L 136 73.5 L 136.5 71 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 72 L 132.5 75 L 128.5 77 L 130.5 74 L 134.5 72 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 74 L 97 74.5 L 94.5 75 L 94.5 74 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 74 L 156 77.5 L 155 77.5 L 155.5 74 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 76 L 88.5 79 L 88 77 L 90.5 76 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 77 L 133 77.5 L 132.5 79 L 135.5 78 L 133.5 81 L 130.5 79 L 131.5 77 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 78 L 101 78.5 L 98.5 79 L 98.5 78 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 78 L 131 80.5 L 128 82.5 L 129 80.5 L 127.5 80 L 126 80.5 L 126.5 78 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 79 L 94 79.5 L 91.5 80 L 91.5 79 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 79 L 124 80.5 Q 123.3 83.1 126 82 L 126 84 L 124 84 Q 125.1 81.3 122.5 82 L 124.5 79 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 80 L 96 81.5 Q 96.8 84.1 93.5 83 L 89 81.5 L 96.5 80 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156 80 Q 159 78.8 158 82.5 L 155.5 89 L 155 84.5 L 156 80 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 82 L 134 82.5 Q 131.3 83.3 132 87.5 L 132.5 89 L 130 87.5 Q 129.3 82.8 132.5 82 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 83 L 122 84.5 L 120.5 85 L 119.5 83 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 83 L 152.5 85 L 153.5 83 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 85 L 127 87 L 125 86.5 L 126.5 85 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 85 L 129 87.5 L 128 87.5 L 128.5 85 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 85 L 135 87 L 133 86.5 L 134.5 85 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 86 Q 83.8 85.3 83 87.5 L 81.5 86 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 86 Q 153.8 85.3 153 87.5 L 150 87.5 L 151.5 86 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 87 L 114 88.5 L 117 94 L 114.5 95 L 115 93.5 L 113 88.5 L 114.5 87 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 88 L 35.5 88 L 37.5 89 Q 39.3 86.3 41 90.5 L 38 89.5 L 37.5 91 L 35 89.5 L 34.5 91 L 33.5 89 L 31.5 94 L 31 92.5 L 32 90.5 L 31.5 89 L 33.5 88 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 88 L 77 91.5 L 76 91.5 L 76.5 88 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 89 L 87 90.5 L 85.5 91 L 83.5 89 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 89 L 111.5 92 L 109 90.5 L 111.5 89 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 91 L 44 91.5 L 40.5 94 L 42.5 91 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 91 L 46.5 93 L 47.5 91 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 91 Q 59.5 92.5 56.5 94 L 56.5 91 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 91 L 62 92.5 L 61.5 94 L 61 92 L 59.5 91 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146 91 L 148 91.5 L 146 92.5 L 146 91 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84 92 Q 87 90.8 86 94.5 L 84 93.5 L 84 92 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107 92 Q 109.7 90.9 109 93.5 L 109.5 95 L 107 94 L 107 92 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 93 L 83 95.5 L 82 95.5 L 81.5 93 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 93 L 106 94.5 L 104.5 95 L 103.5 93 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 93 L 120 95 L 118 94.5 L 119.5 93 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 93 L 122.5 95 Q 119.7 95.7 121.5 93 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43 95 L 45 95.5 L 43 96.5 L 43 95 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 95 Q 55.1 94.2 54 97.5 L 53 97.5 L 52.5 95 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 95 Q 66.8 94.3 66 96.5 L 64 97.5 L 64.5 95 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 95 L 128 95.5 L 128 103.5 L 128.5 105 Q 126.3 104.3 127 106.5 L 128 108.5 L 127 108.5 L 124.5 104 L 119.5 105 L 120 103.5 L 120 96 L 124.5 96 L 125.5 95 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 95 L 142.5 96 L 145 95 L 144 99 L 146.5 98 L 147 100 L 144 101.5 L 145 104.5 L 142.5 105 L 139 104 Q 140.3 107 136.5 106 L 136.5 104 L 133.5 105 L 134 103.5 L 134 96 L 137.5 96 L 138.5 95 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 96 L 77.5 97 L 79 96.5 L 76.5 98 L 75.5 96 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 98 L 42.5 101 L 44 101.5 L 42.5 102 L 41 101.5 L 45 109.5 L 45 112.5 L 44 112.5 L 39 100.5 L 40.5 98 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 98 L 51.5 101 Q 49.3 101.8 50 99.5 L 49.5 98 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 99 L 59 100.5 Q 57.8 103 54 102 L 55.5 99 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 99 L 65 101.5 L 64.5 103 L 63.5 101 L 62 101.5 L 61.5 100 L 61 103 L 65.5 104 L 67 103.5 L 63.5 105 L 59.5 103 L 58 103.5 L 61.5 99 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 99 L 69 99.5 L 66.5 101 L 67.5 99 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 99 L 75.5 101 L 78 99.5 L 75 103.5 L 76 105.5 L 74 104.5 L 75 102.5 L 73 102 L 72 107.5 L 74 107.5 L 71.5 111 L 67 105.5 L 69 104.5 L 68 101 L 70 101.5 L 69 103.5 L 71.5 102 Q 74.1 102.7 73 100 L 71.5 99 Z M 69 105 L 69 107 L 71 108 Q 72 104 69 105 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 102 L 47 103.5 L 46 106 Q 43 107.3 44 103.5 L 46 103.5 L 46.5 102 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 102 L 51.5 102 L 55 103.5 L 53.5 104 L 51 103 Q 52.1 105.7 49.5 105 Q 46.5 103.5 49.5 102 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 103 L 80 103.5 L 77 105 L 77.5 103 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 104 Q 92.3 103.3 93 106.5 L 95 109.5 L 96 116.5 L 95 116.5 Q 94.9 108.1 89.5 105 Q 86.5 105.5 87.5 104 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 105 L 50 106 L 49.5 108 Q 48.2 105.8 47 108.5 L 47 111 L 49 111.5 L 49 120.5 L 51 121 L 51 122.5 L 48.5 121 L 47 120.5 L 48 115.5 L 47 113.5 L 47.5 112 Q 44.1 112.9 46 107.5 L 47.5 105 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 105 L 126 110.5 L 125 112.5 L 128 111.5 L 128 113.5 L 127.5 115 L 126.5 113 L 125.5 115 L 123 111.5 L 125 111 L 123.5 105 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 106 Q 122.8 105.3 122 107.5 L 123 109.5 L 122 109.5 L 120.5 106 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 106 L 133.5 108 L 134.5 106 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141 106 Q 145.6 104.8 147 107.5 L 144.5 108 L 142.5 107 L 141 107.5 L 141 106 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 106 L 154 107.5 L 153.5 110 L 150 107.5 L 151.5 107 Q 153 109.5 154.5 106 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 107 L 138 107.5 L 136 110.5 L 137.5 110 Q 140.7 107.7 147.5 109 L 150 110.5 L 148.5 111 Q 146.8 108.2 140.5 110 L 136.5 113 L 135.5 111 Q 132.8 112.3 134 117.5 L 135 120 L 133 119.5 L 133 111 L 135 110.5 L 134.5 109 Q 137.1 109.7 136 107 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 108 L 164 109.5 L 163.5 111 L 160.5 109 L 159 109.5 L 160.5 108 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 109 L 51 109.5 L 48.5 110 L 48.5 109 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 109 Q 62.5 108.5 63 111.5 L 62 112.5 L 62 120 L 60 119.5 L 60 112.5 L 60.5 111 L 58.5 109 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 109 Q 87 108 88 112.5 L 89 116.5 L 88 121 L 82.5 123 L 78 120.5 L 77 114.5 L 80.5 109 Z M 81 110 L 78 116 L 80 119 L 80 113 L 82 111 L 84 112 L 86 112 Q 85 109 81 110 Z M 84 120 L 83 122 L 86 121 L 84 120 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 111 L 51 119.5 L 50 119.5 L 50.5 111 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 111 L 57 119.5 L 56 119.5 L 56.5 111 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 111 L 65 118.5 L 64 118.5 L 64.5 111 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 113 L 39 114.5 L 38.5 116 L 40 116.5 L 36.5 117 L 37 115.5 L 38.5 113 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 114 L 47 118.5 L 46 118.5 L 45.5 114 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 114 L 119 120.5 L 118 120.5 L 118.5 114 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 115 L 145 115.5 L 142.5 116 L 142.5 115 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 115 L 154 118 L 151 117.5 L 153 117 L 153.5 115 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 118 L 123 120.5 L 122 120.5 L 121.5 118 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 120 L 62 121.5 L 58.5 123 L 58.5 120 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 120 L 121 121.5 L 119 122.5 L 120.5 120 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 120 L 142 122 L 147.5 121 L 148 123 Q 142.6 124.5 141 121.5 L 141.5 120 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 120 L 162 120.5 L 159.5 121 L 159.5 120 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 121 L 136 122.5 L 135 125 Q 132 126 133 123 Q 135.8 124 135.5 121 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 122 L 38 122.5 L 35 123 L 34.5 126 L 34 123.5 L 35.5 122 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 122 L 41 123.5 L 39.5 126 L 39 123.5 L 40.5 122 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 123 L 122.5 125 L 121.5 123 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 124 L 75.5 127 L 73.5 124 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 124 L 113 125.5 L 109.5 128 L 110.5 126 Q 113 126.7 112.5 124 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 124 L 151.5 127 L 152.5 125 L 153 126.5 Q 151.5 129.5 150 126.5 L 150.5 124 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 125 L 138.5 128 L 136.5 127 L 135 127.5 L 136.5 125 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 125 L 156 127.5 L 154 128 L 154.5 125 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 127 L 52 127.5 L 49.5 128 L 49.5 127 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 56 L 114 57.5 L 112 58.5 L 113.5 56 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 56 L 122 57.5 L 121.5 59 L 121 57.5 L 122.5 56 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 56 Q 150 55 151 57.5 L 150 58.5 L 151.5 61 L 148 58.5 L 150 57.5 L 145.5 57 L 145.5 56 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 58 L 116 59.5 L 113.5 63 L 112 60.5 L 115.5 58 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 58 L 126 58.5 L 123.5 60 L 124.5 58 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 58 L 148 60.5 L 146.5 61 L 142.5 59 L 142.5 58 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 61 L 118 63.5 L 116 62.5 L 116.5 61 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 61 L 151 63.5 L 150 63.5 L 149.5 61 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 63 L 96 63.5 L 93.5 64 L 93.5 63 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 64 L 86 65.5 L 84 66.5 L 85.5 64 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 64 L 110 64.5 L 107 65.5 L 109 68.5 L 106.5 67 L 105 66.5 L 107.5 64 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 64 L 116 64.5 L 112 66.5 L 112.5 68 Q 109.5 66.5 112.5 65 L 114.5 64 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 65 Q 84.7 63.9 83 68 L 81 68.5 L 81.5 70 Q 78.8 68.8 81 67.5 L 80.5 65 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 65 L 152 67.5 L 151 67.5 L 150.5 65 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 67 L 156 70.5 L 155 70.5 L 154.5 67 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 67 L 159 71.5 Q 156.8 72.8 158 77.5 L 159 78.5 L 159 86 Q 156.3 87.1 157 84.5 L 158 80.5 L 155.5 73 L 155 78.5 L 156 83.5 L 155 83.5 L 153 72 L 158 72 L 158.5 67 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 73 Q 98.3 72.3 99 74.5 L 97.5 75 L 94.5 74 L 94.5 73 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 73 L 137 77 L 133 79 L 133 77 Q 135.7 78.1 135 75.5 Q 132.8 74.3 135.5 73 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 74 L 94.5 76 L 96 75.5 L 94 78.5 L 95 80.5 L 94 80.5 L 92.5 77 L 89.5 81 L 87 80.5 L 90 80 L 92 76.5 L 90 75.5 L 91.5 74 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 74 L 106 76.5 L 101.5 78 L 99.5 78 L 96.5 79 L 96 77 Q 101.1 78 102.5 74 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 75 L 133 75.5 L 128.5 78 L 128.5 77 L 131.5 75 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 79 L 101 79.5 L 99 80.5 L 99.5 82 L 97 80.5 L 98.5 79 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 79 L 126 79.5 Q 124.9 82.8 127.5 82 L 129.5 83 L 131.5 79 L 132 81 L 136.5 80 L 135.5 82 Q 131 81 130 83.5 L 129.5 88 L 128.5 84 L 127.5 86 L 125.5 82 L 123 83.5 L 124.5 86 L 122 85.5 Q 122.8 83.3 120.5 84 L 119.5 82 Q 124.9 83.9 124 80.5 L 122 80.5 L 123.5 79 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 79 L 128.5 81 L 129.5 79 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 82 L 95.5 83 L 97 82.5 Q 97.9 85.5 93.5 84 L 92 84.5 Q 92.9 81.5 88.5 83 L 88.5 84 L 91 84.5 L 88.5 85 Q 85.5 83.5 88.5 82 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 83 Q 138.5 84.5 135.5 86 L 132 84.5 L 135.5 83 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 88 L 42.5 90 L 43.5 88 L 45.5 91 L 46 89.5 L 45.5 88 L 48 89.5 Q 46.3 93.7 44.5 91 L 41.5 92 L 41.5 90 L 39.5 88 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 88 L 51.5 90 L 52.5 88 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 88 L 76 91.5 L 75 91.5 L 75.5 88 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 88 L 83 89.5 L 82.5 91 L 82 89.5 L 83.5 88 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 88 L 156 89.5 L 155.5 91 L 155 89.5 L 156.5 88 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 89 L 62.5 91 L 64 90.5 L 62.5 93 L 62 91 L 59.5 89 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 89 L 113 89.5 L 115 93.5 L 112.5 92 L 110.5 94 L 109 92.5 L 109.5 91 L 111.5 92 L 110.5 89 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 89 Q 116.8 88.3 116 90.5 L 114.5 89 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 90 Q 58.8 88.9 58 91.5 L 56.5 91 L 55.5 90 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 91 L 83 92 L 81.5 96 L 81 94.5 L 82 93.5 L 80.5 91 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 92 L 106.5 94 L 104 94.5 L 106 95.5 L 104.5 96 L 101 94.5 L 105.5 92 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 92 Q 119.8 91.3 119 93.5 L 116 95.5 Q 115.3 93.3 117.5 94 L 117.5 92 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 93 L 92.5 95 L 93.5 93 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 93 L 157 95.5 L 155 94.5 L 155.5 93 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 94 L 90 96 L 88 95.5 L 89.5 94 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 94 L 99 94.5 L 96.5 96 L 94 95.5 L 95.5 94 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 94 L 111.5 96 L 110 95.5 L 112.5 94 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 94 L 125 96 L 121 95.5 L 124.5 94 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 94 L 152 94.5 L 149.5 95 L 149.5 94 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 95 L 146.5 97 Q 143.7 97.7 145.5 95 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24 97 L 27 97.5 L 25 98 L 24.5 101 L 24 97 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 97 L 80 97.5 L 78 98.5 L 79.5 101 Q 77.3 100.3 78 102.5 L 76.5 105 Q 74.8 101.9 73 103.5 Q 74.3 100.8 75.5 103 L 77 102.5 L 74 100.5 L 75.5 100 Q 76.8 102.3 78 99.5 Q 75.8 98.3 78.5 97 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 99 L 45.5 101 L 47.5 101 Q 50.1 100.3 49 103 L 42.5 101 L 42.5 102 Q 45.1 101.3 44 104 L 41 102.5 L 42 100.5 L 41.5 99 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 99 L 62 100.5 L 61.5 102 L 61 100.5 L 62.5 99 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 100 L 33 102.5 L 31.5 103 L 29.5 100 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 100 L 64 101.5 L 64.5 103 L 67.5 102 L 67.5 103 L 66 103.5 L 68 104.5 L 66.5 105 L 63.5 104 L 62 104.5 L 64.5 100 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 100 L 73 101.5 L 69.5 103 L 69.5 101 Q 66.5 101.5 67.5 100 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145 100 L 150 100.5 Q 145.8 100.3 144.5 103 L 145 101.5 L 145 100 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 101 L 27.5 103 Q 24.7 103.7 26.5 101 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 101 L 37 101.5 L 34 103.5 L 34.5 101 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 101 L 58 102 L 57.5 104 L 55.5 104 L 53.5 101 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 104 L 94.5 105 L 96 104.5 L 93.5 106 L 92.5 104 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 104 L 126 105.5 L 124.5 106 L 123.5 104 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 104 L 133.5 107 L 135.5 104 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 104 L 156 106 L 152.5 108 L 151.5 106 L 152.5 107 L 155.5 104 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 104 Q 167.1 103.3 166 106 L 161 105.5 L 164.5 104 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33 105 L 35 105.5 L 34 108.5 L 33.5 110 Q 30.7 108.8 33 107.5 L 33 105 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 105 L 73.5 107 L 74.5 105 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 105 L 128 106.5 L 126.5 111 L 125 107.5 L 127 107 L 127.5 105 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 105 L 141 106.5 L 140 109 L 135 112.5 L 136 116.5 L 134 115.5 L 134 112.5 L 136 109 L 133 108.5 L 135.5 108 L 138 109 Q 139.1 106.3 136.5 107 L 136.5 106 L 140.5 105 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 106 L 47 106.5 Q 43.5 108 46 109.5 Q 44.9 112.8 47.5 112 L 47 113.5 L 48 116.5 L 46 115.5 L 44 108.5 L 44.5 106 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 106 L 168 108.5 L 167.5 112 L 166 107.5 L 167.5 106 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 107 L 49 108.5 L 47.5 111 L 47 108.5 L 48.5 107 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 107 L 151 108.5 L 149.5 109 L 147.5 108 L 146 108.5 L 147.5 107 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 107 L 164.5 110 Q 161.5 108.5 164.5 107 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 109 L 59 111.5 L 57.5 111 L 56 110.5 L 57.5 109 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 109 L 85.5 112 L 81.5 111 L 80 111.5 Q 79.1 108.1 84.5 110 L 85.5 109 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 110 L 151.5 112 L 150 111.5 L 152.5 110 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 111 L 31.5 113 L 32.5 111 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 112 L 28 116.5 L 27 116.5 L 27.5 112 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 112 L 51 120.5 L 49 119.5 L 49.5 112 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 113 L 30 115.5 L 29 115.5 L 29.5 113 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 113 L 80 117.5 L 78 116.5 L 79.5 113 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 114 L 166 116 L 164 115.5 L 165.5 114 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 115 L 126.5 117 L 127.5 115 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 116 L 120 119 Q 123 117.8 122 121.5 L 122.5 123 L 121 120 Q 117.2 121.2 119.5 116 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 117 L 95.5 119 L 94.5 117 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 117 L 164 117.5 L 161.5 118 L 161.5 117 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 118 L 46.5 120 L 47.5 118 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 118 Q 72.8 117.3 72 119.5 L 70.5 118 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 118 Q 154.8 116.9 154 119.5 L 152 123.5 L 152 125.5 L 151.5 127 L 150 120.5 L 153 119.5 L 151.5 118 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 118 L 167 119.5 L 168 122.5 L 167 122.5 L 165.5 120 Q 163.3 119.3 164 121.5 L 168 127.5 L 167 127.5 L 165 124.5 L 163 124.5 L 164 122 Q 161 123 162 120 L 167.5 118 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 119 L 30 119.5 L 28 120 L 25.5 125 L 24 124.5 L 26 123.5 L 24 120.5 L 25 120.5 L 25.5 122 L 28.5 119 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 119 L 110.5 122 Q 108.3 122.8 109 120.5 Q 110.8 122.1 112.5 119 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 120 L 64 120.5 L 59.5 121 L 59.5 120 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 120 L 84.5 122 L 82 121.5 L 83.5 120 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 121 L 51 124.5 L 48 122.5 L 48.5 121 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 121 L 72 125 L 74 125.5 L 71.5 126 L 70 123.5 L 71.5 121 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 122 L 42.5 124 L 41.5 122 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 123 L 96 125.5 L 95 125.5 L 94.5 123 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111 123 L 113 123.5 L 110 125.5 L 111 123 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 123 L 121 123.5 L 118.5 124 L 118.5 123 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 123 L 136 125.5 L 134.5 128 L 133.5 126 Q 136.4 126.7 135.5 123 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 124 Q 43.5 125.5 40.5 127 L 38 125.5 L 39.5 126 L 41 125.5 L 40.5 124 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 124 L 124.5 126 L 123.5 124 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 125 L 93 126.5 L 91 127.5 L 92.5 125 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 126 L 34.5 128 L 35.5 126 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 126 L 66 127.5 L 64.5 128 L 62.5 128 L 60 127.5 L 63.5 126 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,251,250)",
    stroke: "rgb(250,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 126 L 70 127.5 L 68.5 127 L 67.5 126 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 61 L 150.5 67 L 145.5 61 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 63 L 111.5 71 L 118.5 63 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 64 L 101.5 65 L 106 68.5 L 103.5 67 L 99.5 66 L 100.5 68 L 103 69.5 L 102 71.5 L 103.5 74 Q 100.9 70.6 93.5 72 L 90 74.5 Q 90.9 77.9 85.5 76 L 85.5 74 L 83.5 75 L 81 74 Q 80.2 86.1 88 90.5 L 82 85.5 Q 79.1 81.9 80 74.5 L 84.5 67 L 90.5 64 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 69 L 108.5 71 L 107.5 69 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 72 L 129.5 75 L 131.5 72 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 74 L 107 76.5 L 95.5 86 L 87.5 86 Q 85 85 86 80.5 L 87 80.5 L 87 85 L 95.5 85 L 106 76.5 L 105.5 74 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 75 L 126.5 77 L 127.5 75 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 77 L 121.5 81 L 118.5 83 L 120.5 80 L 124.5 77 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 80 L 139 82.5 L 133.5 90 L 132 89.5 L 136 86.5 L 138.5 80 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 83 L 152 84.5 L 150 85.5 L 151.5 83 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 84 L 126 87.5 L 124.5 88 Q 119.9 86.8 119.5 84 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 87 L 148.5 90 L 150 90.5 Q 147.7 91.8 150.5 93 Q 152.8 93.8 152 91.5 L 153 91.5 L 151.5 94 L 148 93 L 147.5 90 L 143.5 93 L 144.5 91 L 149.5 87 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 88 L 109.5 90 L 107.5 91 L 108.5 89 L 110.5 88 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 88 L 130 88.5 L 127.5 89 L 127.5 88 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 90 L 28 91.5 Q 26.3 97.8 29 99.5 L 27 98.5 Q 25.3 91.8 28.5 90 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 90 L 37 90.5 L 34.5 92 L 35.5 90 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 91 L 73.5 91 L 77 93.5 Q 76.2 96.1 79.5 95 L 81 94.5 L 77.5 96 L 75 95 L 74.5 97 L 74 95.5 L 75 92 L 72.5 93 L 71.5 91 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 91 L 106 91.5 L 100.5 93 L 100.5 92 L 104.5 91 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 91 L 121.5 93 L 120.5 91 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 92 L 47 93.5 L 44.5 95 L 44.5 93 L 43.5 92 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 92 L 69 94.5 L 67 93.5 L 68.5 92 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 93 L 58 93.5 L 56.5 96 L 55.5 93 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 93 L 62 94.5 L 61.5 98 L 60.5 95 L 59 95.5 Q 58.2 92.9 61.5 94 L 62.5 93 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 93 L 99 93.5 L 95.5 94 L 95.5 93 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 94 L 32.5 96 Q 29.7 96.7 31.5 94 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 94 L 66 94.5 L 63.5 96 L 64.5 94 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 95 L 41 97.5 L 40 97.5 L 40.5 95 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 97 L 48 99.5 L 46.5 99 L 45 98.5 L 46.5 97 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 98 L 51.5 100 L 50.5 98 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 98 L 66.5 100 L 67.5 98 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 103 L 147 106 L 149.5 105 L 150 107 L 146 105.5 L 146.5 103 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 104 L 41 104.5 L 35.5 106 L 36.5 104 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 104 L 61 104.5 L 53.5 105 L 53.5 104 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 104 L 114 105.5 L 114 126.5 L 115 127.5 L 113 126.5 L 113 105.5 L 114.5 104 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 104 L 132 104.5 L 129 105 L 128.5 120 L 126.5 117 L 128 117.5 L 128 105.5 L 129.5 104 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 105 L 52 119.5 L 51 119.5 L 51.5 105 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 106 L 68.5 109 L 66.5 106 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 108 L 86.5 110 L 85.5 108 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 108 L 92.5 110 L 91.5 108 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 110 L 37.5 112 L 38.5 110 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 110 L 146 110.5 L 141.5 111 L 141.5 110 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 111 L 123.5 113 L 122.5 111 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 111 L 137.5 114 L 139.5 111 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 112 L 119.5 114 L 118.5 112 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 113 L 94 118.5 L 93 118.5 L 93.5 113 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 114 L 71 116.5 L 70 116.5 L 70.5 114 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 114 L 77 117.5 L 76 117.5 L 76.5 114 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 115 L 121.5 117 L 120.5 115 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 118 L 66 119.5 L 64 120.5 L 65.5 118 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 120 L 79.5 123 L 77.5 120 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 121 Q 41.3 119.3 43 122.5 L 41.5 122 L 34.5 122 L 34.5 121 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 121 L 53 127.5 L 51 126.5 L 51.5 121 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 122 L 66.5 125 L 68.5 122 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 122 L 108 122.5 L 105.5 124 L 106.5 122 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 123 L 85 123.5 L 81.5 124 L 81.5 123 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 123 L 89.5 126 L 91.5 123 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 125 L 139.5 127 L 138.5 125 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 125 L 148.5 127 L 149.5 125 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 125 L 156.5 127 L 155.5 125 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 126 L 108 127.5 L 106.5 128 L 105.5 126 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 126 L 131.5 128 L 132.5 126 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 127 L 85 127.5 L 81.5 128 L 81.5 127 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 127 L 146 127.5 L 142.5 128 L 142.5 127 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(182,197,208)",
    stroke: "rgb(182,197,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 127 L 161 127.5 L 158.5 128 L 158.5 127 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 58 Q 146.1 57.4 151 67.5 L 153 73.5 L 153 79.5 L 152 79.5 L 152 74.5 L 147 69.5 L 149 66.5 Q 146.5 61.7 144 63.5 L 144.5 62 L 136.5 59 L 130.5 59 L 124 61.5 L 126 62.5 L 124.5 63 L 122.5 62 L 117 66.5 L 119 67.5 L 117 68.5 L 116 66.5 Q 120.8 59.8 130.5 58 Z M 150 68 L 149 70 L 151 71 L 150 68 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 65 L 146 68.5 L 138 69 L 137.5 71 L 135.5 70 L 132.5 72 L 133.5 70 L 142.5 67 L 144 67.5 L 144.5 65 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 66 L 103.5 67 L 110.5 72 L 114.5 68 L 116 69.5 L 118.5 74 L 122.5 75 L 124 74.5 L 121 76 Q 119.9 78.7 122.5 78 L 130.5 72 L 128.5 75 L 121.5 80 L 120 79.5 L 118 83.5 Q 123.3 89.3 133.5 90 Q 140.7 86.7 139 74.5 L 138 72.5 L 139 72.5 L 140 76 L 144 76 L 144 77.5 L 145.5 81 L 147 80.5 Q 146.3 82.8 148.5 82 L 149.5 83 L 152 81.5 Q 150.5 88 145.5 91 Q 140.2 96.2 128.5 95 L 128.5 94 L 137 93.5 L 125.5 92 L 125.5 93 L 127 93.5 L 125.5 94 L 116 87.5 Q 116.8 84.9 113.5 86 Q 107.1 93.6 92.5 93 L 83 85.5 L 81 80.5 L 81 74 L 83.5 75 L 85.5 74 L 85.5 76 L 88 76.5 Q 85.3 78.8 86 84.5 L 87.5 86 L 95.5 86 L 107 76.5 L 105.5 74 L 102 71.5 L 103 69.5 L 99.5 66 Z M 115 69 L 113 71 L 115 71 L 115 69 Z M 108 71 L 107 75 L 109 74 L 108 71 Z M 116 84 L 119 89 L 119 88 L 119 86 L 116 84 Z M 139 92 L 139 93 L 141 93 L 139 92 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38 90 Q 41 89 40 92 Q 37 93 38 90 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 90 L 72 90.5 L 71 93 L 74.5 92 L 74.5 93 L 71 94 L 71 99 L 69 99 Q 68 94.8 71 93.5 Q 67.3 91.8 70.5 90 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 91 Q 153.3 90 152 93 L 149.5 91 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77 92 Q 81.5 90.5 80 95 Q 75.5 96.5 77 92 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 93 L 28.5 96 L 28 94 L 30.5 93 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38 93 L 40 93 L 40 99 L 38 98.5 L 39 95.5 L 38 93 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 93 L 45 93.5 L 41.5 95 L 42.5 93 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 93 L 50.5 94 L 53 93 L 50.5 98 L 51 96.5 L 49.5 94 L 47 94.5 L 46.5 97 L 46 94.5 L 47.5 93 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 93 L 62.5 95 L 63.5 93 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 93 L 68 95.5 L 67.5 98 Q 64.6 98.4 66.5 93 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 94 L 37 95 L 37 99 L 35.5 99 L 35 96.5 Q 35.8 94.3 33.5 95 L 33.5 94 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 94 L 59.5 97 L 61 96.5 L 60.5 99 L 59 98.5 Q 59.7 101.1 57 100 Q 55.9 97.3 58.5 98 L 57.5 96 L 56 96.5 L 57.5 94 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 94 L 73.5 96 L 74.5 94 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 97 L 45 98 Q 46 101 43 100 L 42.5 98 L 41 98.5 L 42.5 97 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 97 L 65.5 100 Q 63.3 100.8 64 98.5 L 62 98.5 L 63.5 97 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 97 Q 77.5 98.5 74.5 100 Q 71.5 98.5 74.5 97 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 98 L 54 100 L 52 99.5 L 53.5 98 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147 103 L 150 104.5 L 147 106 L 147 103 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 104 L 84 104.5 L 81.5 105 L 81.5 104 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 105 L 91 107.5 L 89.5 107 L 87.5 105 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 105 L 133 125.5 L 130.5 127 L 130.5 126 L 132 125.5 L 132.5 105 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 106 L 66.5 108 L 65.5 106 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 106 L 74.5 109 L 76.5 106 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 108 L 56 123.5 L 55 123.5 L 55.5 108 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 108 L 77.5 111 L 79.5 108 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 108 L 87.5 110 L 86.5 108 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 109 L 37.5 111 L 38.5 109 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 109 L 93 111.5 L 92 111.5 L 91.5 109 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 110 L 65.5 112 L 64.5 110 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 110 L 119.5 113 L 118 112.5 L 117.5 126 L 117.5 110 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 111 L 153 113.5 L 152 113.5 L 152.5 111 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 111 L 163 113.5 L 162 113.5 L 162.5 111 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 112 L 73 114.5 L 72 114.5 L 72.5 112 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 113 L 90 118.5 L 89 118.5 L 89.5 113 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 113 L 145 113.5 L 140.5 116 L 142.5 113 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 115 L 37 118.5 L 35 117.5 L 35.5 115 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 116 L 151 119.5 L 150 119.5 L 150.5 116 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 117 L 73 119.5 L 72 119.5 L 72.5 117 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 117 L 147 117.5 L 140.5 118 L 140.5 117 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 118 L 128.5 121 L 126.5 118 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 119 L 124.5 121 L 123.5 119 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 121 L 63.5 123 L 57.5 124 L 57.5 123 Q 62.8 123.8 64.5 121 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 121 L 65.5 125 L 68.5 121 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 121 L 78.5 123 L 77.5 121 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 122 L 85.5 124 L 86.5 122 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 122 L 88.5 126 L 91.5 122 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 122 L 126.5 124 L 125.5 122 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 122 L 141.5 124 L 140.5 122 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 123 L 76.5 126 L 74.5 123 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 123 L 105.5 125 L 106.5 123 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 123 L 110 125.5 L 108 126.5 L 109 124.5 L 108.5 123 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 123 L 150 124.5 L 148.5 124 L 143.5 125 L 143.5 124 L 147.5 123 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 124 L 163 126.5 L 162 126.5 L 162.5 124 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 125 L 128.5 127 L 127.5 125 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(102,118,161)",
    stroke: "rgb(102,118,161)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 126 L 62 126.5 L 59.5 127 L 59.5 126 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 59 L 140.5 60 L 149 66.5 L 151 70.5 L 149 69.5 L 148.5 68 L 147 69.5 L 152 74.5 Q 153.5 81.5 149.5 83 L 147 82 L 146.5 80 L 145 80.5 L 144 76 L 140 76 L 140 74.5 L 138 69 L 146 68.5 L 144.5 65 L 143.5 68 L 141.5 68 L 137.5 68 L 121 78 Q 119.9 75.3 122.5 76 L 122.5 75 L 117 72.5 L 116.5 71 L 114.5 71 L 112 72.5 L 111.5 74 L 111 72.5 L 115 67 Q 120.9 61.7 130.5 59 Z M 117 67 L 117 69 L 119 68 L 117 67 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 70 L 109 73.5 L 107 74.5 L 106.5 70 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116 84 L 120 86.5 L 118.5 89 L 116 84 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 91 L 33 98.5 L 31 97.5 L 30 94 Q 26.5 95.1 28.5 91 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 91 L 36 94.5 L 34 93.5 L 35.5 91 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 92 Q 72.5 93.5 69.5 95 L 69.5 92 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 92 L 137 93.5 L 127.5 94 L 125.5 92 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 92 L 141 92.5 L 138.5 93 L 138.5 92 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 93 L 56 94.5 Q 56.8 98.3 54.5 99 L 55 97.5 Q 56.5 93.1 53.5 94 L 53.5 93 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58 93 L 60 93.5 L 59 95.5 Q 62.8 97.3 59.5 99 Q 61.1 97.3 58 95.5 L 58 93 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 93 L 66 93.5 L 63 95.5 L 64 98.5 L 62 97.5 Q 61.5 93.5 64.5 93 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73 93 L 75 93.5 L 73 94.5 L 73 93 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 94 L 48 98.5 L 47 98.5 L 47.5 94 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 94 L 51 95.5 L 53 98.5 L 51 99 L 50 95.5 L 51.5 94 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 95 L 39 97.5 L 38 97.5 L 38.5 95 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 95 L 43 98.5 L 41 97.5 L 41.5 95 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 96 L 75 98.5 L 73 97.5 L 73.5 96 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36 105 Q 39.8 104 41 106.5 L 48 127 L 44 126 L 43 121 L 34.5 121 L 33 122.5 L 32 127 Q 27.9 128.7 29 124.5 L 36 105 Z M 39 109 L 35 116 L 37 119 L 40 118 L 41 119 L 39 109 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52 105 Q 63 103.5 68 108 Q 70.7 110.6 70 117.5 Q 68.6 123.6 63.5 126 L 56.5 127 L 54.5 127 L 52 126.5 L 52 105 Z M 55 108 L 55 124 L 64 123 L 67 117 L 66 112 Q 63 106 55 108 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 105 L 86.5 105 L 91 108.5 Q 94.2 111.8 93 119.5 L 87.5 126 L 80.5 127 L 74 122.5 L 72 115.5 Q 72.9 108.9 77.5 106 L 79.5 105 Z M 83 107 L 80 108 L 76 113 L 77 122 Q 79 125 86 124 L 90 119 Q 91 112 88 110 L 83 107 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114 105 Q 118.7 104 120 107.5 L 128.5 121 L 129 105 L 132 105.5 L 132 126 L 129.5 127 L 117.5 110 L 117 127 L 114 125.5 L 114 105 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 107 Q 159.8 105.9 159 108.5 Q 156.8 109.8 159.5 111 Q 163.7 109.9 162 114 L 159 114.5 L 159 123.5 L 162 124.5 Q 163.3 128.7 158.5 127 L 156 126 Q 153.8 122.3 155 114 Q 151.7 115.1 153 111 Q 156 112.3 155 108.5 L 156.5 107 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 111 Q 147.3 110.2 149 113.5 L 150 120 L 140.5 120 L 140 122.5 Q 141.4 125.6 146.5 125 L 149 124 Q 150.1 126.7 147.5 126 Q 146.3 128.2 141.5 127 L 138 124.5 L 136 118.5 L 139.5 112 L 141.5 111 Z M 143 113 Q 139 114 140 118 L 147 118 L 147 116 Q 147 113 143 113 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(39,25,63)",
    stroke: "rgb(39,25,63)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 123 L 109 125.5 L 106.5 127 Q 103 125 107.5 123 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 56 L 141 56.5 L 138.5 57 L 138.5 56 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 57 L 119.5 59 L 118 58.5 L 120.5 57 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 57 L 137 57.5 L 131.5 58 L 131.5 57 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 57 L 145 57.5 L 142.5 58 L 142.5 57 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 58 L 125 59.5 L 123.5 59 L 122.5 58 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 61 L 119.5 63 L 120.5 61 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 64 L 102.5 66 L 103.5 64 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 65 L 85.5 67 L 86.5 65 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 65 L 114.5 67 L 115.5 65 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 66 L 106.5 69 L 104.5 66 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 66 L 111.5 68 L 112.5 66 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 67 L 83 68.5 L 80.5 74 L 80 71.5 L 83.5 67 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 70 L 153.5 72 L 152.5 70 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 72 Q 101.8 70.8 105 74.5 L 103.5 75 Q 101.2 71.8 94.5 73 L 90.5 75 L 91.5 73 L 93.5 72 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 72 L 131.5 74 L 132.5 72 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 74 L 154 80.5 L 153 80.5 L 153.5 74 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 75 L 127.5 77 L 128.5 75 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 76 L 139 80 L 137 79.5 L 138.5 76 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 77 L 124.5 79 L 125.5 77 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 78 L 90 79.5 L 88.5 80 L 87.5 78 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 78 L 101.5 81 L 103.5 78 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 82 L 97.5 84 L 98.5 82 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 84 L 81 85.5 L 82.5 88 Q 83.8 85.8 85 88.5 Q 83.3 86.9 81.5 90 Q 79.3 89.3 80 91.5 L 81 93.5 L 80 93.5 L 78.5 91 L 76 92.5 L 82 88.5 L 80 85.5 L 81.5 84 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 84 L 96 84.5 L 93.5 85 L 93.5 84 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 85 L 133.5 88 L 136 86.5 Q 134 91 132 87.5 L 132.5 85 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 86 L 114.5 88 Q 119.5 87.5 120 91.5 L 117 90.5 L 116.5 92 L 116 90.5 L 116.5 89 L 113.5 88 L 111.5 89 L 112.5 87 L 114.5 86 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 88 L 35 88.5 L 33.5 91 L 32.5 88 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 88 L 38.5 90 L 37.5 88 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 88 L 72.5 90 L 73.5 88 L 74 90.5 L 71 92.5 L 72 90 L 70 89.5 L 71.5 88 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 89 L 29.5 91 L 30.5 89 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 89 L 51.5 91 L 50 90.5 L 52.5 89 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 89 L 152.5 91 L 150 90.5 L 151.5 89 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 90 L 40.5 92 L 41.5 90 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 90 L 49 91.5 L 47 92.5 L 48.5 90 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 90 L 54.5 93 Q 51.5 91.5 54.5 90 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 90 L 59 91.5 L 58.5 93 L 58 91.5 L 59.5 90 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 90 Q 85.8 89.3 85 91.5 L 83.5 90 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 91 Q 40.3 92.3 38 93.5 L 37.5 95 L 37 93.5 L 37.5 91 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 91 L 60.5 93 L 61.5 91 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 92 L 148 94 L 142 95 L 142.5 93 L 145.5 94 L 147.5 92 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 93 L 102 93.5 L 99.5 94 L 99.5 93 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 94 L 121 96 L 119 95.5 L 120.5 94 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 95 Q 50.7 93.9 50 96.5 L 49 98.5 L 51 102.5 L 50 102.5 Q 47 100.3 48 95 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 95 L 69 98.5 L 68 98.5 L 68.5 95 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 95 L 73 99 L 71 98.5 L 72.5 95 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 95 L 136 95.5 L 130.5 96 L 130.5 95 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 96 L 30.5 100 L 32 99.5 Q 30.5 102.5 29 99.5 L 29.5 96 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 96 L 58.5 98 Q 55.7 98.7 57.5 96 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 96 L 76.5 99 Q 73.5 97.5 76.5 96 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 97 L 46 97.5 L 43.5 98 L 43.5 97 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 98 L 27.5 100 Q 24.7 100.7 26.5 98 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 101 L 40.5 104 L 38 103 L 38.5 101 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 101 L 46.5 104 L 48 103.5 L 46.5 106 L 44 102.5 L 44.5 101 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 102 L 52.5 104 L 53.5 102 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 102 L 61.5 105 Q 58.5 103.5 61.5 102 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 102 L 151 103.5 L 150.5 107 L 150 103 Q 146.7 103.8 147.5 102 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 103 L 32.5 105 L 33.5 103 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 104 L 119.5 106 L 118.5 104 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 104 L 133.5 106 L 132.5 104 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 104 L 154 105.5 L 152 106.5 L 153.5 104 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 104 L 160 106 L 158 105.5 L 159.5 104 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 105 L 71 107.5 L 69 106.5 L 69.5 105 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 105 L 74.5 108 L 76.5 105 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 105 L 91.5 108 L 89.5 105 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 105 L 146.5 107 L 145.5 105 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 106 L 124 109.5 L 122 110.5 L 123 108.5 L 122.5 106 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 106 L 157 106.5 L 154.5 108 L 155.5 106 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56 108 L 59 108.5 L 56.5 110 L 56 108 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 108 L 85 108.5 L 81.5 109 L 81.5 108 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 108 L 146 108.5 L 143.5 109 L 143.5 108 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 109 L 79.5 112 Q 76.5 110.5 79.5 109 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 109 L 155 109.5 Q 155.8 111.8 153.5 111 L 152.5 109 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 110 L 166 110.5 L 164 111 L 163.5 113 L 163 111.5 L 164.5 110 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 111 L 71 113.5 L 70 113.5 L 70.5 111 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 111 L 127 113.5 L 125.5 116 L 126 114.5 L 125.5 113 L 124 113.5 L 126.5 111 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 112 L 151 113.5 L 150.5 115 L 150 113.5 L 151.5 112 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 113 L 119.5 115 L 118.5 113 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 114 L 41 116.5 L 39 117.5 L 39 115.5 L 39.5 114 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 114 L 141.5 116 L 142.5 114 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 114 L 163 114.5 Q 163.8 116.8 161.5 116 L 160.5 114 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 115 L 155 124.5 L 154 124.5 L 154.5 115 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 117 L 136 120.5 L 134 121.5 L 135.5 117 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 120 L 83.5 122 L 84.5 120 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 120 L 104.5 122 L 105.5 120 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 120 L 150 120.5 L 144.5 122 L 142.5 120 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 121 L 85.5 123 L 86.5 121 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 122 L 36 125.5 L 35 125.5 L 34.5 122 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 122 L 125.5 124 L 124.5 122 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 122 L 160.5 124 L 159.5 122 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 123 L 147 123.5 L 143.5 124 L 143.5 123 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 124 L 76.5 127 L 74.5 124 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 124 L 119 127 L 121 127.5 L 119.5 128 Q 117 127 118.5 124 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 125 L 28 127 L 30 127.5 L 28.5 128 L 27.5 125 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 125 L 51 127 L 45.5 128 L 45.5 127 Q 49.8 127.8 50.5 125 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 125 L 112.5 127 L 111.5 125 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 125 L 127.5 127 L 126.5 125 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 125 L 138.5 127 L 137.5 125 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 126 L 90.5 128 L 91.5 126 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 126 L 150.5 128 L 149.5 126 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(240,240,240)",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 127 L 60 127.5 L 53.5 128 L 53.5 127 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdonet);
export default __webpack_public_path__ + "static/media/adonet.bc27877b455b560518fa6159106241b6.svg";
export { ForwardRef as ReactComponent };